<template>
  <div id="admin-clients-header">
    <el-row id="search-conditions-form">
      <el-form :inline="true">
        <el-form-item label="得意先コード">
          <el-input v-model="id"></el-input>
        </el-form-item>
        <!-- <el-form-item label="得意先名">
          <el-input v-model="name"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="search(filterConditions)"
            >絞り込み</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="text" v-if="isInitial" @click="releaseCondition"
            >絞り込みを解除</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: "",
    };
  },
  computed: {
    // 絞り込みボタン実装。空文字 or nullで非表示。
    isInitial () {
      if (
        this.id === "" ||
        this.id === null
      ) {
        return false;
      }
      return true;
    },
    /**
     * @return {object}
     */
    filterConditions: function () {
      return {
        id: this.id,
      };
    },
  },
  methods: {
    /**
     * @param {object} filterConditions
     */
    search (filterConditions) {
      this.$emit("onSearchClientGroups", {
        q: filterConditions,
      });
    },
    releaseCondition () {
      this.$emit("onSearchClientGroups", {
        q: null,
      });
      this.id = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

#admin-clients-header #search-conditions-form {
  padding: 22px 20px;
  padding-bottom: 0px;
}
#admin-clients-header #search-conditions-form .el-form-item {
  margin-right: 0px;
}
#admin-clients-header #search-conditions-form .el-form-item + .el-form-item {
  margin-left: 24px;
}
</style>
